import { Preset } from './constants.mjs';
import { Type } from '../plugins/inlines/token/types.mjs';
import { TextReplacementPlugin } from '../plugins/abstract/text-replacement/TextReplacementPlugin.mjs';
import { TokenPlugin } from '../plugins/inlines/token/TokenPlugin.mjs';
import { HotkeyPlugin } from '../plugins/abstract/hotkey/HotkeyPlugin.mjs';
import { DisableTextAttributesPlugin } from '../plugins/abstract/disable-text-attributes/DisableTextAttributesPlugin.mjs';
import { DisableLineBreakPlugin } from '../plugins/abstract/disable-line-break/DisableLineBreakPlugin.mjs';
import { SoftBreakPlugin } from '../plugins/abstract/soft-break/SoftBreakPlugin.mjs';
import { BoldPlugin, Type as Type$1 } from '../plugins/marks/bold/BoldPlugin.mjs';
import { ItalicPlugin, Type as Type$2 } from '../plugins/marks/italic/ItalicPlugin.mjs';
import { LinkPlugin } from '../plugins/inlines/link/LinkPlugin.mjs';
import { Type as Type$3 } from '../plugins/inlines/link/types.mjs';
import { StrikethroughPlugin } from '../plugins/marks/strikethrough/StrikethroughPlugin.mjs';
import { UnderlinePlugin, Type as Type$4 } from '../plugins/marks/underline/UnderlinePlugin.mjs';
import { ParagraphPlugin, Type as Type$5 } from '../plugins/blocks/paragraph/ParagraphPlugin.mjs';
import { ListPlugin } from '../plugins/blocks/list/ListPlugin.mjs';
import { ListType } from '../plugins/blocks/list/constants.mjs';
import { ListItemPlugin } from '../plugins/blocks/list/ListItemPlugin.mjs';
import { HeadingPlugin, Type as Type$6 } from '../plugins/blocks/heading/HeadingPlugin.mjs';

function createPreset(preset, options) {
  const textReplacementOptions = options == null ? void 0 : options.textReplacements;
  const tokenOptions = options == null ? void 0 : options[Type];
  const textReplacementPlugin = textReplacementOptions ? [TextReplacementPlugin({
    replacements: textReplacementOptions
  })] : [];
  const tokenPlugin = tokenOptions ? [TokenPlugin(tokenOptions)] : [];
  const hotkeyPlugin = options != null && options.hotkeys ? [HotkeyPlugin({
    hotkeys: options.hotkeys
  })] : [];
  const sideEffects = (options == null ? void 0 : options.sideEffects) || [];
  const additionalPlugins = (options == null ? void 0 : options.additionalPlugins) || [];
  const commonPlugins = [
  // Order of the text replacement plugin is important, it should come before
  // other leaf serializers in order to update the text of leaves before they
  // are serialized by other plugins
  ...textReplacementPlugin, ...tokenPlugin, ...hotkeyPlugin, ...additionalPlugins];
  if (preset === Preset.Text) {
    return [...commonPlugins, DisableTextAttributesPlugin(),
    // The order of the `DisableLineBreakPlugin` is important
    // It should come after all other plugins that have pre/post serialization logic
    DisableLineBreakPlugin()];
  }
  if (preset === Preset.TextWithSoftBreaks) {
    return [...commonPlugins, DisableTextAttributesPlugin(), SoftBreakPlugin({
      insertLineBreak(event) {
        if (event.key === 'Enter') {
          if (event.metaKey || event.altKey || event.ctrlKey) {
            return false;
          }
          return true;
        }
        return false;
      },
      replaceNewLinesWithBreaks: false
    })];
  }
  const richTextPlugins = [...commonPlugins, BoldPlugin(options == null ? void 0 : options[Type$1]), ItalicPlugin(options == null ? void 0 : options[Type$2]), LinkPlugin({
    ...(options == null ? void 0 : options[Type$3]),
    sideEffects
  }), StrikethroughPlugin(), UnderlinePlugin(options == null ? void 0 : options[Type$4])];
  if (preset === Preset.InlineRichText) {
    return [...richTextPlugins, DisableLineBreakPlugin()];
  }
  const commonRichTextPresetPlugins = [...richTextPlugins, ParagraphPlugin({
    sideEffects
  }), SoftBreakPlugin()];
  const richTextWithLists = [...commonRichTextPresetPlugins, ListPlugin({
    ...(options == null ? void 0 : options[ListType]),
    sideEffects
  }), ListItemPlugin({
    sideEffects: options == null ? void 0 : options.sideEffects,
    defaultBlockType: Type$5
  })];
  if (preset === Preset.RichTextWithLists) {
    return richTextWithLists;
  }
  if (preset === Preset.ThemeEditorRichText) {
    return [...richTextWithLists, HeadingPlugin({
      ...(options == null ? void 0 : options[Type$6]),
      sideEffects
    })];
  }
  if (preset === Preset.MetafieldRichText) {
    return [...commonPlugins, BoldPlugin(options == null ? void 0 : options[Type$1]), ItalicPlugin(options == null ? void 0 : options[Type$2]), LinkPlugin({
      ...(options == null ? void 0 : options[Type$3]),
      sideEffects
    }), StrikethroughPlugin(), ParagraphPlugin({
      sideEffects
    }), SoftBreakPlugin(), ListPlugin({
      ...(options == null ? void 0 : options[ListType]),
      sideEffects
    }), ListItemPlugin({
      sideEffects: options == null ? void 0 : options.sideEffects,
      defaultBlockType: Type$5
    }), HeadingPlugin({
      ...(options == null ? void 0 : options[Type$6]),
      sideEffects
    })];
  }
  return commonRichTextPresetPlugins;
}

export { createPreset };
